export enum LocalStorageKey {
  AuthorizationToken = 'com_at',
  SelectedBrand = 'com_sb',
  AppSettings = 'com_as',
  LegalFormDetailsState = 'com_lfds'
}
